import React from 'react';
import { identity } from 'lodash';

type ValueProps = {
  value?: any;
  formatter?: (value: any) => any;
  style?: React.CSSProperties;
};

const Value = ({
  value = null,
  formatter = identity,
  style,
  ...props
}: ValueProps) => {
  return (
    <div style={style ?? {}} {...props}>
      {formatter(value)}
    </div>
  );
};

export default Value;
